import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';

export type CurveConfigJson =  {
  color: ColorConfigJson;
  thickness: number;
};

export class CurveConfig implements JsonConfigInterface<CurveConfigJson> {

  public readonly color: ColorConfig = new ColorConfig();

  private _thickness: number = 0;

  constructor(json?: CurveConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get thickness(): number {
    return this._thickness;
  }

  public deserializeJson(json: CurveConfigJson): void {
    this.color.deserializeJson(json.color);
    this._thickness = json.thickness;
  }
}
